export enum MasterDataTypeId {
  accessForDialysis = 37,
  acquisitionSource = 18,
  alcoholIntake = 21,
  attritionReason = 30,
  bedType = 29,
  billStatus = 24,
  bloodGroup = 16,
  causeOfHospitalisation = 47,
  chewTobacco = 23,
  confirmationOfStroke = 48,
  country = 9,
  covidVaccine = 36,
  dateType = 38,
  dialysateReportType = 58,
  dieticianRateReason = 56,
  dose = 44,
  event = 46,
  excercise = 20,
  frequency = 43,
  frequencyStatus = 45, 
  gender = 15,
  govtId = 14,
  guestReferType = 62,
  guestReferenceUserType = 65,
  guestType = 12,
  guestTypeBO = 12,
  insuranceStatus = 3,
  ipOp = 11,
  itemType = 2,
  kidneyCause = 27,
  levelOfEducation = 25,
  maritalStatus = 17,
  masterReportType = 58,
  messageType = 57,
  modeOfDeposit = 53,
  nephrologistRatingreason = 63,
  operationsReportType = 760,
  paymentStatus = 73,
  paymentType = 33,
  price = 40,
  priority = 49,
  projectType = 4,
  qualityReportType = 761,
  qualityType = 763,
  ratingReason = 55,
  ratingValue = 57,
  reportType = 57,
  roles = 28,
  rrStatus = 51,
  rrType = 50,
  salutation = 13,
  smokingStatus = 22,
  state = 8,
  typeOfEvent = 46,
  unit = 54,
  userStatus = 39,
  viralMarkerType = 41,
  workingStatus = 26,
  caste = 81,
  category = 86,
  debitMaster = 84,
  debitPopUpMaster = 85,
  debitNoteStatus = 83,
  guestCategory = 82,
  autoInventoryTimeZone = 88,
  assetResolutionType = 91,
  assetRRTypes = 92,
  machineStatus = 93,
  taskPriority = 94,
  requestStatus = 95,
  serviceTicketIssueCategory = 100,
  auditStatus = 101,
  active = 39,
  centerTypeId = 10,
  nullifybillstatus = 102,
  typeOfDiabetes = 103, 
  typeOfDialysisMembrane = 104,
  typeOfModality = 105,
  causeOfDeath = 106,
  transplantationType = 107,
  cardiovascularEventType = 108
}

export enum MasterDataOthers {
  othersMasterId = 518,
}